import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { api } from "@/lib/api";
import { fadeUp, stagger, viewportOnce } from "@/lib/motion";
import { IMAGES } from "@/data/content";

export default function NewsSection() {
  const [news, setNews] = useState([]);

  useEffect(() => {
    api.get("/news").then((r) => setNews(r.data)).catch(() => {});
  }, []);

  return (
    <section id="noticias" className="px-4 sm:px-8 lg:px-16 py-20 lg:py-32">
      <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={viewportOnce}>
        <motion.p variants={fadeUp} className="overline-label text-[#4A0E17]/60">Chancelaria</motion.p>
        <motion.h2 variants={fadeUp} className="font-display mt-4 text-4xl sm:text-5xl font-bold uppercase leading-tight text-[#1C1917]">
          Notícias da Diocese
        </motion.h2>

        <div className="mt-12 grid md:grid-cols-3 gap-8">
          {news.map((n, i) => (
            <motion.div
              key={n.id || i}
              variants={fadeUp}
              data-testid={`news-article-card-${i + 1}`}
            >
              <Link to={`/noticias/${n.slug || n.id}`} className="group block cursor-pointer">
                <div className="overflow-hidden">
                  <img
                    src={n.image || IMAGES.altar}
                    alt={n.image_alt || n.title}
                    loading="lazy"
                    className="aspect-[4/3] w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div className="pt-5">
                  <p className="overline-label text-[#C5A059]">{n.category} • {n.date_label}</p>
                  <h3 className="font-display mt-3 text-lg font-bold leading-snug text-[#1C1917] group-hover:text-[#4A0E17] transition-colors">{n.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-[#1C1917]/60 line-clamp-3">{n.excerpt}</p>
                  <span className="overline-label mt-4 inline-block border-b border-[#C5A059] pb-1 text-[#4A0E17]">Ler na íntegra</span>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
}
